import React from 'react';
import { BasicCard, Empty, IconTextButton } from 'ui-lib';

interface IComponentVersionEmptyStateProps {
    title: string;
    description: string;
    actionLabel?: string;
    onAction?: () => void;
    image?: string;
}

export const ComponentVersionEmptyState = (props: IComponentVersionEmptyStateProps): JSX.Element => {
    return (
        <BasicCard
            title={props.title}
            contents={[
                <Empty key='empty' image={props.image || 'simple'} description={props.description} />,
            ]}
            footers={
                props.onAction
                    ? <IconTextButton label={props.actionLabel || 'Back'} type='primary' onClick={props.onAction} />
                    : undefined
            }
        />
    );
};
